module.exports = __webpack_public_path__ + "img/logo.595342f0.png";